import { useState } from "react";
import { toast } from "sonner";
import { http, errMsg } from "../../lib/api";

export const LiveToggle = ({ k, reload, className = "w-full mt-2" }) => {
  const [busy, setBusy] = useState(false);
  const live = !!k.product?.published;
  if (k.bespoke || (!live && !k.ready)) return null;
  const flip = async (e) => {
    e.preventDefault(); e.stopPropagation();
    setBusy(true);
    try {
      await http.put(`/kits/${k.id}/product`, { ...k.product, published: !live });
      toast.success(live ? `${k.destination} taken off the live site — still Ready` : `${k.destination} is live`);
      reload();
    } catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };
  return (
    <button data-testid={`kit-live-toggle-${k.id}`} onClick={flip} disabled={busy} title={live ? "Take off the live site" : "Put on the live site"}
      className={`${className} rounded-sm px-1.5 py-1 text-[10px] font-mono-ui uppercase tracking-wider border transition-colors disabled:opacity-50 ${live
        ? "border-emerald-300 bg-emerald-50 text-emerald-800 hover:bg-emerald-100" : "border-sky-300 bg-sky-50 text-sky-800 hover:bg-sky-100"}`}>
      {busy ? "…" : live ? "Live · take off" : "Ready · not published"}
    </button>
  );
};
